
export enum LedStatus
{
    Idle = "Idle",
    CameraHalted = "CameraIsHalted",
    CameraConnected = "CameraConnected",
    CameraDisconnected = "CameraDisconnected",
    NewPictureReceived = "NewPictureReceived",
    InputActive = "InputActive",
    ProblemWithCamera = "ProblemWithCamera",
    ServerConnected = "ServerConnected",
    ServerDisconnected = "ServerDisconnected",
    // InputInactive = "InputInactive",
    // Launching = "Launching",
    Unauthorized = "Unauthorized"
}
